import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { initialize, loggedIn } from '@app/core/guards';
import { provideProfileStore } from '@app/store/profile';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: initialize(),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routing').then(({ routes }) => routes),
    },
    {
        path: '',
        canActivate: [loggedIn()],
        component: ShellComponent,
        providers: [...provideProfileStore()],
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.routing').then(({ routes }) => routes),
            },
            {
                path: 'admins',
                loadChildren: () => import('./admins/admins.routing').then(({ routes }) => routes),
            },
            {
                path: 'users',
                loadChildren: () => import('./users/users.routing').then(({ routes }) => routes),
            },
            {
                path: 'stations',
                loadChildren: () => import('./stations/stations.routing').then(({ routes }) => routes),
            },
            {
                path: 'racks',
                loadChildren: () => import('./racks/racks.routing').then(({ routes }) => routes),
            },
            {
                path: 'printers',
                loadChildren: () => import('./printers/printers.routing').then(({ routes }) => routes),
            },
            {
                path: 'products',
                loadChildren: () => import('./products/products.routing').then(({ routes }) => routes),
            },
            {
                path: 'cartons',
                loadChildren: () => import('./cartons/cartons.routing').then(({ routes }) => routes),
            },
            {
                path: 'pallets',
                loadChildren: () => import('./pallets/pallets.routing').then(({ routes }) => routes),
            },
            {
                path: 'scan-logs',
                loadChildren: () => import('./scan-logs/scan-logs.routing').then(({ routes }) => routes),
            },
            {
                path: 'print-jobs',
                loadChildren: () => import('./print-jobs/print-jobs.routing').then(({ routes }) => routes),
            },
            {
                path: 'metrics',
                loadChildren: () => import('./metrics/metrics.routing').then(({ routes }) => routes),
            },
            {
                path: 'reports',
                loadChildren: () => import('./reports/reports.routing').then(({ routes }) => routes),
            },
            {
                path: 'warehouse-assignments',
                loadChildren: () => import('./warehouse-assignments/warehouse-assignments.routing').then(({ routes }) => routes),
            },
            {
                path: 'system-configurations',
                loadChildren: () => import('./system-configurations/system-configurations.routing').then(({ routes }) => routes),
            },
            {
                path: 'test-flow',
                loadChildren: () => import('./test-flow/test-flow.routing').then(({ routes }) => routes),
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.routing').then(({ routes }) => routes),
            },
            {
                path: 'storytelling',
                loadChildren: () => import('./storytelling/storytelling.routing').then(({ routes }) => routes),
            },
            {
                path: '**',
                loadChildren: () => import('@error/not-found').then(({ routes }) => routes),
            },
        ],
    },
];
